import {
  blocksOptionsConfig,
  newCollectionTemplate,
} from "@components/cmsBlocks/configs";

export const typeSlider = blocksOptionsConfig.collectionTypes.sliderV4.value;

export const sliderConfig = newCollectionTemplate({
  typeFields: {
    firstName: "text",
    secondName: "text",
    quote: "textarea",
    isShow: "boolean",
  },
  itemTemplate: {
    firstName: "",
    secondName: "",
    quote: "",
    isShow: true,
  },
  type: typeSlider,
  showAsTitle: "firstName, secondName", // only texts fields
  allowUseSets: false,
});

// export const sliderConfig1 = {
//   typeFields: {
//     firstName: "text",
//     secondName: "text",
//     quote: "textarea",
//   },
//   itemTemplate: {
//     firstName: "",
//     secondName: "",
//     quote: "",
//   },
//   type: typeSlider,
//   showAsTitle: "firstName, secondName", // only texts fields
//   allowUseSets: false,
// };

export const initBlockData = {
  title: "People behind Lux Express",
  collections: {
    [typeSlider]: {
      ...sliderConfig,
      items: [
        {
          isShow: true,
          firstName: "Aistė",
          secondName: "",
          quote:
            "I chose Lux Express for my trip to Tallinn and was pleasantly surprised with the experience. Coaches were clean, drivers were kind, the trip time flew by while watching the movies!",
        },
        {
          isShow: true,
          firstName: "Toomas",
          secondName: "",
          quote:
            "I chose Lux Express for my trip to Tallinn and was pleasantly surprised with the experience. Coaches were clean, drivers were kind, the trip time flew by while watching the movies!",
        },
        {
          isShow: true,
          firstName: "Anastasia",
          secondName: "",
          quote:
            "I chose Lux Express for my trip to Tallinn and was pleasantly surprised with the experience. Coaches were clean, drivers were kind, the trip time flew by while watching the movies!",
        },
      ],
    },
  },
};

export const initEmptyBlockData = {
  title: "",
  collections: {
    [typeSlider]: {
      ...sliderConfig,
      items: [],
    },
  },
};
